var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatingStarExtension(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.563 1.005c.324-.866 1.55-.866 1.874 0l.806 2.157a1 1 0 0 0 .893.649l2.3.1c.925.04 1.303 1.206.58 1.782l-1.803 1.433a1 1 0 0 0-.34 1.05l.615 2.219c.247.891-.745 1.612-1.516 1.101l-1.92-1.27a1 1 0 0 0-1.104 0l-1.92 1.27c-.771.51-1.763-.21-1.516-1.101l.616-2.219a1 1 0 0 0-.341-1.05L.984 5.693C.261 5.117.64 3.95 1.564 3.91l2.3-.1a1 1 0 0 0 .893-.65l.806-2.156Z",
    fill: "#157F3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStarExtension);
export default __webpack_public_path__ + "static/media/rating-star-extension.4b0112394036d00eca9eda6f37100c51.svg";
export { ForwardRef as ReactComponent };